/* eslint-disable no-shadow */
export enum FilterSections {
	ozonersList = 'ozonersList',
	vehiclesList = 'vehiclesList',
	creditsList = 'creditsList',
	formsList = 'formsList',
	ozociosList = 'ozociosList',
	extVehicleList = 'extVehicleList',
}

export enum Roles {
	ADMIN = 'ADMIN',
	INVENTORY_MANAGER = 'INVENTORY_MANAGER',
	INVENTORY_PRICE_MANAGER = 'INVENTORY_PRICE_MANAGER',
	INVENTORY_MODEL_MANAGER = 'INVENTORY_MODEL_MANAGER',
	INVENTORY_DEVICE_MANAGER = 'INVENTORY_DEVICE_MANAGER',
	DEVICES_MANAGER = 'DEVICES_MANAGER',
	CREDIT_ANALYST = 'CREDIT_ANALYST',
	COLLECTOR_MANAGER = 'COLLECTOR_MANAGER',
	WALMART_MANAGER = 'WALMART_MANAGER',
	BUYER_MANAGER = 'BUYER_MANAGER',
	RECUPERATOR_MANAGER = 'RECUPERATOR_MANAGER',
	RECUPERATOR_AGENT = 'RECUPERATOR_AGENT',
	GPS_VIEWER = 'GPS_VIEWER',
	GPS_MANAGER = 'GPS_MANAGER',
	SELLER = 'SELLER',
	USER_MANAGMENT = 'USER_MANAGMENT',
	SYSTEM = 'SYSTEM',
}
